import { KeyboardBackspaceIcon } from './KeyboardBackspaceIcon';

/**
 * author: Google
 * id 21C8B558-8398-43E8-A79A-8BA99BE693D6
 * name keyboard-backspace
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-backspace.svg
 * tags
 */
export const KeyboardClearIcon = KeyboardBackspaceIcon;
export default KeyboardClearIcon